module.exports = __webpack_public_path__ + "img/digestive.34aa2b29.jpg";